var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bf-btn",class:( _obj = {}, _obj[("icon-" + _vm.iconPosition)] = true, _obj ),on:{"click":_vm.btn2ClickTrigger}},[(_vm.icon && !_vm.loading)?_c('bf-icon',{staticClass:"bficon",attrs:{"icon-name":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('bf-icon',{staticClass:"loading bficon",attrs:{"icon-name":"loading"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"slot-wrapper"},[_vm._t("default")],2)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d6f5bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/button/btn2/btn2.vue
// module id = 33
// module chunks = 0